var React = require('react');

function MenuPlaylistIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M12.765 11.094H2.24c-.317 0-.576-.25-.576-.556V2.462c0-.306.259-.556.576-.556h3.035c.148 0 .297.056.394.15L7.04 3.45c.34.338.814.531 1.302.531h4.418c.317 0 .576.25.576.556v5.998c0 .307-.255.557-.571.559m-.005-8.305H8.342c-.153 0-.307-.061-.41-.164l-1.38-1.402C6.216.899 5.743.714 5.254.714H2.24C1.241.714.43 1.498.43 2.462v8.076c0 .964.812 1.748 1.811 1.748h10.528c.483-.002.937-.186 1.278-.518.34-.332.528-.77.525-1.235V4.537c0-.964-.812-1.748-1.811-1.748"}));
}

MenuPlaylistIcon.defaultProps = {"width":"15","height":"13","viewBox":"0 0 15 13"};

module.exports = MenuPlaylistIcon;

MenuPlaylistIcon.default = MenuPlaylistIcon;
